import DataObject from '../../../common/model/DataObject';

import ContractRangeList from './ContractRangeList';
import Counterparty from './Counterparty';
import ContractAlertList from './ContractAlertList';
import DataConnectorList from './DataConnectorList';
import Parameters from './Parameters';

export default class Contract extends DataObject {
  getPropertyNames() {
    return [
      'guid',
      'code',
      'displayName',
      'counterpartyGuid',
      'counterpartyCode',
      'isActive',
      'hourlyEnergyMaximum',
      'hourlyEnergyMinimum',
      'hourlyEnergyNonElectable',
      'contractRanges',
      'inputDataChannel',
      'subhourlyResolution',
      'electionRange',
      'tradeCutOffTime',
      'tradeCutOffWarning',
      'showContractLimits',
      'enforcePackageRules',
      'princeSubmissionACode',
      'princeSubmissionBCode',
      'sataConfiguration',
      'parameters',
      'alerts',
      'outputDataConnectors'
    ];
  }

  getDefaultOverrides() {
    return {
      guid: () => crypto.randomUUID()
    };
  }

  getChildClassTypes() {
    return {
      contractRanges: ContractRangeList,
      parameters: Parameters,
      alerts: ContractAlertList,
      outputDataConnectors: DataConnectorList
    };
  }

  getMappedProjectedPropertyValues() {
    return {
      counterpartyGuid: {
        classType: Counterparty,
        propertyName: 'guid',
        mode: 'overwrite',
        nestedPath: []
      },
      counterpartyCode: {
        classType: Counterparty,
        propertyName: 'code',
        mode: 'overwrite',
        nestedPath: []
      },
      parameters: {
        classType: Counterparty,
        propertyName: 'templateName',
        mode: 'match-schema',
        nestedPath: [
          'parameters',
          'contractParameterSchema'
        ]
      }
    };
  }
}